import { useContext } from 'react';
import * as React from 'react';

import type { OperationVariables, QueryResult } from '@apollo/client';
import { noop } from 'lodash';

import type { NotificationResponse } from '../NotificationsWidget/queries';
import type { SourceHelpers } from '../Source/Source';
import type { SubscribedNotificationsResponse } from '../Source/SubscribedNotificationSource/queries';

export type SubscribedNotificationsContext = {
  subscribedNotifications: NotificationResponse[];
  subscribedNotificationHelpers: SourceHelpers<NotificationResponse>;
  queryResult?: QueryResult<SubscribedNotificationsResponse, OperationVariables>;
};

const context = React.createContext<SubscribedNotificationsContext>({
  subscribedNotifications: [],
  subscribedNotificationHelpers: {
    writeToStore: noop,
    deleteFromStore: noop,
  },
  queryResult: undefined,
});

const useSubscribedNotifications = () => useContext(context);

const { Provider, Consumer } = context;

export { Provider, Consumer, useSubscribedNotifications };
